<form>
  <spk-card title="Search Queues">
    <spk-search-grid #grid list="QueueEntrySearchRow" defaultSortProperty="QueueEntryId DESC" [customFormats]="customFormats"></spk-search-grid>
  </spk-card>

</form>